.head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 8px; }
.title { font-size: 14px; font-weight: 600; color: var(--text); }
.toggle {
  padding: 3px 10px; font-size: 11.5px; color: var(--blue);
  background: none; border: 1px solid var(--blue); border-radius: var(--r-pill); cursor: pointer;
}

.note {
  margin-bottom: 8px; padding: 8px 10px; font-size: 12px; line-height: 1.5;
  color: var(--text2); background: var(--table-even); border-radius: var(--r-sm);
}

/* Панель тёмная в обеих темах: это изображение оборудования,
   а не элемент интерфейса */
.faceplate {
  display: flex; gap: 14px; align-items: flex-start;
  padding: 10px 12px; overflow-x: auto;
  background: #2b2f33; border-radius: var(--r-md);
}
.group { flex-shrink: 0; }
.groupLabel { margin-bottom: 4px; font-size: 10px; color: #9aa3a9; font-family: var(--mono); }

/* Нечётные порты сверху, чётные снизу — заполнение по столбцам */
.grid { display: grid; grid-template-rows: repeat(2, auto); grid-auto-flow: column; gap: 4px; }
.oneRow { grid-template-rows: auto; }

.port {
  width: 26px; height: 22px; padding: 0;
  font-size: 10px; font-weight: 700; color: #fff;
  border: none; border-radius: 3px; cursor: pointer;
}
.port:focus-visible { outline: 2px solid #fff; outline-offset: 1px; }

.access { /* цвет задаётся из номера VLAN */ }
.trunk { color: #2b2f33; background: repeating-linear-gradient(45deg, #cfd5d9 0 4px, #f1f3f4 4px 8px); }
.trunkAll { color: #2b2f33; background: repeating-linear-gradient(45deg, #b3bcc2 0 3px, #f1f3f4 3px 6px); }
.none { color: #9aa3a9; background: transparent; box-shadow: inset 0 0 0 1px #6c757d; }
.disabled { color: #6c757d; background: #3d4247; }

.selected { box-shadow: 0 0 0 2px #fff; }
.dimmed { opacity: .18; }

.details {
  margin-top: 8px; padding: 9px 11px;
  background: var(--table-even); border-radius: var(--r-sm); font-size: 12px;
}
.detailsName { margin-bottom: 5px; font-family: var(--mono); font-weight: 700; }
.row { display: flex; gap: 10px; padding: 2px 0; }
.rowLabel { min-width: 110px; color: var(--text2); }

.legend { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 10px; }
.chip {
  display: inline-flex; align-items: center; gap: 5px;
  padding: 3px 9px; font-size: 11.5px; color: var(--text);
  background: var(--card-bg); border: 1px solid var(--border); border-radius: var(--r-pill); cursor: pointer;
}
.chipActive { border-color: var(--blue); box-shadow: 0 0 0 1px var(--blue); }
.swatch { width: 10px; height: 10px; border-radius: 2px; flex-shrink: 0; }
.chipCount { color: var(--text2); }

.totals { margin-top: 8px; font-size: 11.5px; color: var(--text2); }

.logical { margin-top: 8px; font-size: 12px; color: var(--text2); }
.logical summary { cursor: pointer; }
.logicalRow { padding: 2px 0 2px 12px; }
.mono { font-family: var(--mono); }

.demo {
  margin-bottom: 8px; padding: 9px 11px; font-size: 12px; line-height: 1.5;
  color: var(--warn); background: var(--warn-bg);
  border-left: 3px solid var(--warn); border-radius: var(--r-sm);
}
